var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", fill: "none", viewBox: "0 0 32 32" }, props),
    React.createElement("circle", { cx: "16", cy: "16", r: "16", fill: "#F8F0FB" }),
    React.createElement("path", { stroke: "#BB6BD9", strokeWidth: "2", d: "M16.43 20.14l-4.75 3.16a.5.5 0 0 1-.76-.54l1.38-5.7-4.15-3.22a.5.5 0 0 1 .3-.9h5.66l1.85-5.53a.5.5 0 0 1 .95 0l1.85 5.53h5.7a.5.5 0 0 1 .29.9l-4.44 3.22L22 22.7a.5.5 0 0 1-.75.56l-4.8-3.12z" })
  );
});